<template>
  <div
    class="modal fade"
    id="loginModal"
    ref="modal"
    tabindex="-1"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="loginModalLabel">{{'Session expired' | translate}}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="password-modal-input">{{'Password' | translate}}</label>
            <input type="password" name="password" id="password-modal-input" class="form-control" v-model="password">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="login">{{'Log in now' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {return {
    password: '',
  }},
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal, {})
  },
  methods: {
    login() {
      axios.get('/home/refresh-token')
      .then(({data}) => {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.token;
      })
      .then(() => {
        return this.$api.login(this.credentials)
      })
      .then(({data}) => {
        if (data.email) {
          this.close()
        }
      })
    },
    close() {
      window.location.reload()
    },
    open(action) {
      this.modal.show()
    },
  },
  computed: {
    credentials() {
      return {
        password: this.password,
        email: this.$store.state.user.email
      }
    },
  },
}
</script>

<style></style>
